// import React from "react";

// export const LdServices = (props) => {
//     return (
//         <div id="services" className="text-center">
//             <div className="container">
//                 <div className="section-title">
//                     <h2>para você e para sua empresa</h2>
//                 </div>
//                 <div className="row d-flex-start">
//                     {props.data
//                         ? props.data.line.map((d, i) => (
//                             <div key={`${d.name}-${i}`} className="col-md-4 col-xs-12">
//                                 {" "}
//                                 <i className={d.icon}></i>
//                                 <div className="service-desc">
//                                     <h3>{d.name}</h3>
//                                     <p>{d.text}</p>
//                                 </div>
//                             </div>
//                         ))
//                         : "loading"}
//                 </div>
//                 <div className="row d-flex-start">
//                     {props.data
//                         ? props.data.line2.map((d, i) => (
//                             <div key={`${d.name}-${i}`} className="col-md-4 col-xs-12">
//                                 {" "}
//                                 <i className={d.icon}></i>
//                                 <div className="service-desc">
//                                     <h3>{d.name}</h3>
//                                     <p>{d.text}</p>
//                                 </div>
//                             </div>
//                         ))
//                         : "loading"}
//                 </div>
//             </div>
//         </div>
//     );
// };

import React from "react";

export const LdServices = (props) => {
  // Combine line and line2 into a single array
  const services = [
    ...(props.data?.line || []),
    ...(props.data?.line2 || []),
    ...(props.data?.line3 || []),
  ];

  // Function to chunk array into groups of three
  const chunkArray = (array, size) => {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };

  // Create rows with up to 3 items each
  const serviceRows = chunkArray(services, 3);

  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>para você e para sua empresa</h2>
        </div>
        {services.length > 0
          ? serviceRows.map((row, rowIndex) => (
              <div key={`row-${rowIndex}`} className="row d-flex-start">
                {row.map((d, i) => (
                  <div key={`${d.name}-${i}`} className="col-md-4 col-xs-12">
                    <i className={d.icon}></i>
                    <div className="service-desc">
                      <h3>{d.name}</h3>
                      <p>{d.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            ))
          : "loading"}
      </div>
    </div>
  );
};
